export default __webpack_public_path__ + "static/media/or-lavie.f05e06e4.png";